//



if (typeof scaaffCheck === 'undefined') {
    scaaffCheck = false;
}
if (!scaaffCheck) {
    scaaffCheck = true;

    function scaaff_is_installed() {
        var isInstalled = false;
        var scripts = document.getElementsByTagName('script');

        for (var i = 0; i < scripts.length; ++i) {
            var url = scripts[i].getAttribute("src");
            if(scripts[i].innerText.indexOf('asyncLoad') >= 0 && scripts[i].innerText.indexOf("sca_affiliate_dev.js") >= 0
                ||(url && url.indexOf('shop=') >= 0 && url.indexOf("sca_affiliate_dev.js") >= 0) ) {
                console.log('already has scripttag, load AFF');
                isInstalled = true;
                break;
            }
        }
        return isInstalled;
    }

    if (scaaff_is_installed()) {
        // console.log('aaa');
        var scaAppUrl = "https://12ad30e7.ngrok.io";
        // var scaAppUrl = "https://affiliate.test";
        var scaCdn = "https://12ad30e7.ngrok.io";
        // var scaCdn = "https://affiliate.test";

        var scaLoadScript = function(url, callback) {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            if (script.readyState) {
                script.onreadystatechange = function() {
                    if (script.readyState == 'loaded' || script.readyState == 'complete') {
                        script.onreadystatechange = null;
                        callback();
                    }
                }
            } else {
                script.onload = function() {
                    callback();
                }
            }

            script.src = url;
            document.getElementsByTagName('head')[0].appendChild(script);
        };
        function scaParseQueryString(query) {
            var vars = query.split("&");
            var query_string = {};
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                var key = decodeURIComponent(pair[0]);
                var value = decodeURIComponent(pair[1]);
                // If first entry with this name
                if (typeof query_string[key] === "undefined") {
                    query_string[key] = decodeURIComponent(value);
                    // If second entry with this name
                } else if (typeof query_string[key] === "string") {
                    var arr = [query_string[key], decodeURIComponent(value)];
                    query_string[key] = arr;
                    // If third or later entry with this name
                } else {
                    query_string[key].push(decodeURIComponent(value));
                }
            }
            return query_string;
        }

        function scaSetCookie(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            var expires = "expires="+ d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }

        function scaGetCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for(var i = 0; i <ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "none";
        }

        function scaGetShopName() {
            var index = Shopify.shop.indexOf('myshopify.com');
            return Shopify.shop.substr(0,index-1);
        }


        function scaPostClickTracking(data,scaAffInterval) {
            jQuerySCAAF.ajax({
                type: 'POST',
                async: false,
                // url: 'https://af.secomapp.com/api/click_tracking',
                url: scaAppUrl+'/api/click_tracking',
                // url: 'https://4ede4d52.ngrok.io/api/click_tracking',
                crossDomain: true,
                data: data,
                dataType: 'json',
                success: function(responseData, textStatus, jqXHR)
                {
                    if(responseData.status == "ok") {
                        localStorage.setItem( "scaaf_tid", responseData.tid );
                        localStorage.setItem( "scaaf_ep", responseData.ep*1000 );

                        scaSetCookie('scaaf_tid', responseData.tid, 360);
                        scaSetCookie('scaaf_ep', responseData.ep*1000, 360);
                        localStorage.setItem('scaaf_received', 'true');
                    }else{
                        clearInterval(scaAffInterval);
                    }
                },
                error: function (responseData, textStatus, errorThrown)
                {
                    console.warn(responseData, textStatus, errorThrown);
                    clearInterval(scaAffInterval);
                }
            });
        }

        function scaPostCartToken(data, scaPostCartToken) {
            jQuerySCAAF.ajax({
                type: 'POST',
                async: false,
                // url: 'https://af.secomapp.com/api/ctk',
                url: scaAppUrl+'/api/ctk',
                // url: 'https://4ede4d52.ngrok.io/api/ctk',
                crossDomain: true,
                data: data,
                dataType: 'json',
                success: function(responseData, textStatus, jqXHR)
                {
                    if(responseData.status == "ok") {
                        scaSetCookie('scaaf_tid', responseData.tid, 360);
                        localStorage.setItem( "scaaf_tid", responseData.tid );
                        localStorage.setItem( "scaaf_ctk", data['ctk']);
                        scaSetCookie('scaaf_ctk', data['ctk'], 360);
                        localStorage.setItem('scaaf_received', 'true');
                        scaGetCouponCode();
                    }else{
                        clearInterval(scaAffInterval);
                    }
                },
                error: function (responseData, textStatus, errorThrown)
                {
                    console.warn(responseData, textStatus, errorThrown);
                    clearInterval(scaAffInterval);
                }
            });
        }

        function restoreLocalStorage(aid, tid, cc, ctk, ep) {
            localStorage.setItem( "scaaf_aid", aid );
            localStorage.setItem( "scaaf_tid", tid );
            localStorage.setItem( "scaaf_c_c", cc );
            localStorage.setItem( "scaaf_ctk", ctk );
            localStorage.setItem( "scaaf_ep", ep );
        }

        function scaPostCheckoutToken() {
            let data = {
                aid: localStorage.getItem("scaaf_aid"),
                ct_tk: Shopify.Checkout.token,
                s: shopName,
                hc: localStorage.getItem("scaaf_hc")
            }

            jQuerySCAAF.ajax({
                type: 'POST',
                async: false,
                // url: 'https://af.secomapp.com/api/ct_tk',
                url: scaAppUrl+'/api/ct_tk',
                // url: 'https://4ede4d52.ngrok.io/api/ct_tk',
                crossDomain: true,
                data: data,
                dataType: 'json',
                success: function(responseData, textStatus, jqXHR)
                {
                    if(responseData.status == "ok") {

                    }
                },
                error: function (responseData, textStatus, errorThrown)
                {
                    console.warn(responseData, textStatus, errorThrown);
                }
            });
        }

        function scaPostAffiliatePurchase(event){
            var a = event.target;
            jQuerySCAAF(a).text("Loading....");
            jQuerySCAAF(a).prop('disabled', true);
            data = {
                email:Shopify.checkout.email,
                first_name:Shopify.checkout.billing_address.first_name,
                last_name:Shopify.checkout.billing_address.last_name,
                shop:Shopify.shop
            };
            jQuerySCAAF.ajax({
                type: 'POST',
                async: true,
                // url: 'https://af.secomapp.com/api/ct_tk',
                url: scaAppUrl+'/api/post_affiliate_purchase',
                // url: 'https://4ede4d52.ngrok.io/api/ct_tk',
                crossDomain: true,
                data: data,
                dataType: 'json',
                beforeSend: function(){
                    jQuerySCAAF(a).text("Loading....");
                },
                success: function(responseData, textStatus, jqXHR)
                {
                    if(responseData.status == "ok") {
                        let inputText =  '<div class="result_wrapper" style="display: flex;padding:20px;">'+
                            '<div class="input-link-wrapper" style="flex-grow: 1;">'+
                            '<input class="sca_ip" id="sca_referral_link_ip" style="border: 1px solid rgba(33,33,33,.12);color:#237392;font-weight:600;padding:10px;width:100%;" type="text" name="" value="'+ responseData.referral_link +'">'+
                            '</div>'+
                            '<button class="sca_bt sca_btn_copy" id="sca_popup_copy_btn" onclick="scaCopy('+ "'"+ 'sca_referral_link_ip' + "',"+ "'"+ 'sca_popup_copy_btn' +"'"+')" style="margin-left: 15px;" >Copy link</button>'+
                            '</div>';
                        let buttonSocial =  '<a href="https://www.facebook.com/sharer.php?u='+ responseData.referral_link +'" title="Share on Facebook" target="_blank"><img src="'+scaCdn+'/icons/facebook.svg"></a>'+
                            '<a href="https://twitter.com/intent/tweet?url='+ responseData.referral_link +'" title="Share on Twitter" target="_blank"><img src="'+scaCdn+'/icons/twitter.svg"></a>'+
                            '<a href="http://pinterest.com/pin/create/link/?url='+ responseData.referral_link +'" title="Share on Pinterest" target="_blank"><img src="'+scaCdn+'/icons/pinterest.svg"></a>'+
                            '<a href="https://www.linkedin.com/shareArticle?mini=true&amp;url='+ responseData.referral_link +'" title="Share on LinkedIn" target="_blank"><img src="'+scaCdn+'/icons/linkedin.svg"></a>';

                        jQuerySCAAF('#sca_result_wrapper').html(inputText);
                        jQuerySCAAF('#sca_share').html(buttonSocial);
                        jQuerySCAAF('#sca_share').show();
                    }
                },
                error: function (responseData, textStatus, errorThrown)
                {
                    console.warn(responseData, textStatus, errorThrown);
                }
            });
        };

        function scaShowPurchasePopup(setting){
            let css = '.sca_modal_overlay{z-index:1000;position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.6);display:flex;justify-content:center;align-items:center}.sca_modal_container{background-color:#fff;max-height:100vh;margin-left:8px;margin-right:8px;border-radius:4px;overflow-y:auto;box-sizing:border-box}.sca_modal_header{display:flex;justify-content:space-between;align-items:center}.sca_modal_title{margin-top:0;margin-bottom:0;font-weight:600;font-size:1.25rem;line-height:1.25;color:#00449e;box-sizing:border-box}.sca_modal_close{background:0 0;border:0}.x-btn{font-size:18px}.modal_content{margin-top:2rem;margin-bottom:2rem;line-height:1.5;color:rgba(0,0,0,.8)}.modal_btn{font-size:.875rem;background-color:#e6e6e6;color:rgba(0,0,0,.8);border-radius:.25rem;border-style:none;border-width:0;cursor:pointer;-webkit-appearance:button;text-transform:none;overflow:visible;line-height:1.15;margin:0;will-change:transform;-moz-osx-font-smoothing:grayscale;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-transform:translateZ(0);transform:translateZ(0);transition:-webkit-transform .25s ease-out;transition:transform .25s ease-out;transition:transform .25s ease-out,-webkit-transform .25s ease-out;padding:.5rem 1rem}.modal_btn:focus,.modal_btn:hover{-webkit-transform:scale(1.05);transform:scale(1.05)}.modal_btn-primary{background-color:#00449e;color:#fff}@keyframes mmfadeIn{from{opacity:0}to{opacity:1}}@keyframes mmfadeOut{from{opacity:1}to{opacity:0}}@keyframes mmslideIn{from{transform:translateY(15%)}to{transform:translateY(0)}}@keyframes mmslideOut{from{transform:translateY(0)}to{transform:translateY(-10%)}}.sml{display:none}.sml.is-open{display:block}.sml[aria-hidden=false] .sca_modal_overlay{animation:mmfadeIn .3s cubic-bezier(0,0,.2,1)}.sml[aria-hidden=false] .sca_modal_container{animation:mmslideIn .3s cubic-bezier(0,0,.2,1)}.sml[aria-hidden=true] .sca_modal_overlay{animation:mmfadeOut .3s cubic-bezier(0,0,.2,1)}.sml[aria-hidden=true] .sca_modal_container{animation:mmslideOut .3s cubic-bezier(0,0,.2,1)}.sml .sca_modal_container,.sml .sca_modal_overlay{will-change:transform}#sca_main{text-align:center}#sca_content{max-width:400px;width:80%;display:inline-block;overflow:hidden}#sca_title{font-size:1.2rem;text-align:center;padding:16px 8px 2px}#sca_subtitle{font-size:.8rem;opacity:.9;text-align:center;padding:8px 4px}.x-btn{position:absolute;top:4px;right:8px;cursor: pointer;border-radius: 0.25rem;background-color: lightgray;padding:0px 6px 4px 6px;}#sca_share{padding:10px 0 12px;background-color:#efefef;text-align:center}#sca_share a{text-decoration:none;margin:4px;width:32px;height:32px;display:inline-block}#sca_share a:hover,#sca_share a:visited{text-decoration:none;margin:4px;width:32px;height:32px;display:inline-block}#sca_share img{width:28px;height:28px;margin:2px;transition:.1s}.sca_input_block_parent{margin:16px 4px}.sca_input_block{display:flex;border-radius:2px;border:1px solid #ced4da}.sca_input{border:transparent;background:0 0;outline:0;flex:1;padding:0 4px;opacity:.75;font-size:1rem}.sca_copy_button{background-color:#efefef;border-color:transparent;padding:4px;height:100%;min-width:60px;min-height:32px;font-size:1rem}.sca_copy_button:hover{background-color:#ddd}.input_label{font-weight:700;font-size:.8rem;display:inline-block;width:100%;margin:0;padding:0;text-align:left}#sca_reg_mode_manual_btn{font-size:1.2rem;display:inline-block;padding:.8rem 1rem;margin:1rem;text-decoration:none;box-shadow:0 0 12px #bbb}.sca_input-group{display:table;border-collapse:collapse;width:100%}.sca_input-group>div{display:table-cell;border:1px solid #ddd;vertical-align:middle}.sca_input-group-icon{background:#eee;color:#777;padding:0 12px}.sca_input-group-area{width:100%}.sca_input-group input{border:0;display:block;width:100%;padding:8px}.sca_ip{-webkit-writing-mode:horizontal-tb!important;text-rendering:auto;color:initial;letter-spacing:normal;word-spacing:normal;text-transform:none;text-indent:0;text-shadow:none;display:inline-block;text-align:start;-webkit-appearance:textfield;background-color:#fff;-webkit-rtl-ordering:logical;cursor:text;margin:0;font:400 13.3333px Arial;padding:1px 0;border-width:2px;border-style:inset;border-color:initial;border-image:initial}.sca_bt{-webkit-appearance:button;-webkit-writing-mode:horizontal-tb!important;text-rendering:auto;color:buttontext;letter-spacing:normal;word-spacing:normal;text-transform:none;text-indent:0;text-shadow:none;display:inline-block;text-align:center;align-items:flex-start;cursor:default;background-color:buttonface;box-sizing:border-box;margin:0;font:400 13.3333px Arial;padding:1px 6px;border-width:2px;border-style:outset;border-color:buttonface;border-image:initial}';
            jQuerySCAAF('head').append('<style type="text/css">'+ css +'</style>');
            let popup = '<div id="sca_purchase_popup_modal_container">'+
                '<div class="sml is-open" id="modal-1" aria-hidden="false">'+
                '<div class="sca_modal_overlay" id="sca_modal_overlay" tabindex="-1" data-micromodal-close="">'+
                '<div class="sca_modal_container" id="modal_container" role="dialog" aria-modal="true" aria-labelledby="modal-1-title" style="max-width: '+setting.image_width+'px; width: 90%;">'+
                '<button class="sca_modal_close x-btn" aria-label="Close modal" data-micromodal-close="">x'+
                '</button>'+
                '<div id="sca_popup">'+
                '<div id="sca_img" style="background-image: url('+ scaCdn + '/' + setting.header_image +'); background-position: center center; background-repeat: no-repeat; background-size: cover; width: 100%; height: '+ setting.image_height +'px;"></div>'+
                '<div id="sca_main" style="display: block;">'+
                '<div id="sca_content">'+
                '<h2 id="sca_title" style="font-size:24px;color:'+ setting.title_color +';">'+ setting.title +'</h2>'+
                '<div id="sca_subtitle" style="color:'+ setting.subtitle_color +';">'+setting.sub_title+'</div>'+
                '<div id="sca_result_wrapper"><a onclick="scaPostAffiliatePurchase(event)" id="sca_reg_mode_manual_btn"  style="cursor: pointer;background-color: '+ setting.button_background +'; color: '+ setting.button_text_color +'; border-radius: '+ setting.button_border_radius +'px; ">'+ setting.button_text +' <div class="loader"></div></a></div>'+
                '</div>'+
                '</div>'+
                '<div id="sca_share" style="display:none">'+

                '</div>'+
                '</div>'+
                '</div>'+
                '</div>'+
                '</div>'+
                '</div>';
            jQuerySCAAF('body').append(popup);
        }

        function scaCopyToClipboard(el) {

            // resolve the element
            el = (typeof el === 'string') ? document.querySelector(el) : el;

            // handle iOS as a special case
            if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {

                // save current contentEditable/readOnly status
                var editable = el.contentEditable;
                var readOnly = el.readOnly;

                // convert to editable with readonly to stop iOS keyboard opening
                el.contentEditable = true;
                el.readOnly = true;

                // create a selectable range
                var range = document.createRange();
                range.selectNodeContents(el);

                // select the range
                var selection = window.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);
                el.setSelectionRange(0, 999999);

                // restore contentEditable/readOnly to original state
                el.contentEditable = editable;
                el.readOnly = readOnly;
            }
            else {
                el.select();
            }

            // execute copy command
            document.execCommand('copy');
        }
        function scaCopy(text, btn){
            var input = document.getElementById(text);
            var btnCopy = document.getElementById(btn);
            // input.select();
            // document.execCommand("copy");
            scaCopyToClipboard(input);
            btnCopy.innerHTML  = "Copied"
            setTimeout(function(){ btnCopy.innerHTML = "Copy link" }, 1000);
        }
        var shopName = scaGetShopName();

        function scaGetCouponCode() {
            if (scaGetCookie('scaaf_aid') !== 'none') {
                jQuerySCAAF.ajax({
                    type: 'GET',
                    url: scaAppUrl+'/api/get_coupon',
                    crossDomain: true,
                    data: {
                        aid: scaGetCookie('scaaf_aid')
                    },
                    dataType: 'json',
                    success: function(responseData, textStatus, jqXHR) {
                        if(responseData.status == "ok") {
                            var couponCode = responseData.coupon;
                            if (scaGetCookie('scaaf_cp') === 'none' || couponCode != scaGetCookie('scaaf_cp')) {
                                scaSetCookie('scaaf_cp', couponCode, 360);
                                var couponUrl = encodeURI('/discount/' + couponCode);
                                $('body').prepend('<iframe src="'+couponUrl+'" height=0 width=0 frameborder=0 marginheight=0 marginwidth=0 scrolling=no onload="scroll(0,0);"></iframe>');
                            }
                        }
                    }
                });
            }
        }

        scaLoadScript('//code.jquery.com/jquery-3.0.0.min.js', function() {

            jQuerySCAAF = jQuery.noConflict(true);
            scaGetCouponCode();
            var query = window.location.search.substring(1);
            var qs = scaParseQueryString(query);
            var trackingId = localStorage.getItem("scaaf_tid");
            var checkoutTk = scaGetCookie('tracked_start_checkout');
            if ( typeof qs.sca_ref !== 'undefined' ) {
                var exp = qs.sca_ref.split('.');
                var data = {
                    aid: exp[0],
                    hc: exp[1],
                    s: shopName,
                    tid:trackingId
                };
                var lastClick = localStorage.getItem("scaaf_c_c");
                var ctime = new Date().getTime();
                localStorage.setItem('scaaf_received', 'false');
                localStorage.setItem("scaaf_aid", data['aid']);
                localStorage.setItem("scaaf_hc", data['hc']);
                localStorage.setItem("scaaf_c_c", ctime);
                scaSetCookie('scaaf_aid', data['aid'], 360);
                scaSetCookie('scaaf_c_c', ctime, 360);

                if (lastClick == null) {
                    scaPostClickTracking( data );
                }else{
                    if (ctime-lastClick > 60*1000){
                        scaPostClickTracking( data );
                    }
                }
                if(typeof qs.sca_rib !== 'undefined' ) {
                    window.location.href = qs.sca_rib;

                }

            }

            if( localStorage.getItem("scaaf_aid") != null && Shopify.Checkout && Shopify.Checkout.token ) {
                scaPostCheckoutToken();
            }

            var scaAffInterval = setInterval(function(){
                var scaCartToken = localStorage.getItem("scaaf_ctk");
                var cartTokenCookie = scaGetCookie('cart');
                if ( cartTokenCookie !== "none") {
                    if ( localStorage.getItem("scaaf_tid") != null && localStorage.getItem("scaaf_aid") != null ) {
                        var expired = localStorage.getItem("scaaf_ep");
                        if (expired != null && expired < new Date().getTime()) {
                            clearInterval(scaAffInterval);
                            return '';
                        }
                        if ( cartTokenCookie != scaCartToken ) {
                            var data = {
                                aid: localStorage.getItem("scaaf_aid"),
                                tid: localStorage.getItem("scaaf_tid"),
                                ctk: cartTokenCookie,
                                s: shopName
                            };
                            scaPostCartToken(data, scaAffInterval);

                        }
                    }else{
                        var tidCookie = scaGetCookie('scaaf_tid');
                        var aidCookie = scaGetCookie('scaaf_aid');
                        if( tidCookie !== "none" && aidCookie !== "none") {
                            var ctkCookie = scaGetCookie('scaaf_ctk');
                            var ccCookie = scaGetCookie('scaaf_c_c');
                            var epCookie = scaGetCookie('scaaf_ep');
                            restoreLocalStorage(aidCookie, tidCookie, ccCookie, ctkCookie, epCookie);
                        }
                    }

                    if (localStorage.getItem('scaaf_received') == 'false') {
                        var data = {
                            aid: localStorage.getItem("scaaf_aid"),
                            hc: localStorage.getItem("scaaf_hc"),
                            s: shopName,
                            tid:localStorage.getItem("scaaf_tid")
                        };
                        scaPostClickTracking(data, scaAffInterval);
                    }
                }

            }, 1000);


            //purchase popup
            if(Shopify.Checkout) {
                if(Shopify.checkout.email) {
                    jQuerySCAAF.ajax({
                        type: 'GET',
                        // url: 'https://af.secomapp.com/api/ctk',
                        url: scaAppUrl+'/api/purchase_popup/setting',
                        // url: 'https://4ede4d52.ngrok.io/api/ctk',
                        crossDomain: true,
                        data: {
                            shop: Shopify.shop,
                            email: Shopify.checkout.email

                        },
                        dataType: 'json',
                        success: function(responseData, textStatus, jqXHR)
                        {
                            if(responseData.status == "ok") {
                                let settings = responseData.settings;
                                if( scaGetCookie('sca_p_p_show_once') == "none" || settings.show_only_once==0 ) {
                                    scaShowPurchasePopup(settings.design);
                                    if( settings.close_background_click == 1 ){
                                        window.onclick = function(event) {

                                            var overlay = document.getElementById("sca_modal_overlay");
                                            if (event.target == overlay) {
                                                overlay.style.display = "none";
                                            }
                                        }
                                    }

                                    if( settings.show_only_once == 1 ){
                                        scaSetCookie('sca_p_p_show_once', 1, 365);
                                    }
                                }

                            }
                        },
                        error: function (responseData, textStatus, errorThrown)
                        {
                            console.warn(responseData, textStatus, errorThrown);
                        }
                    });

                    jQuerySCAAF(document).on('click','.sca_modal_close', function(){
                        jQuerySCAAF('#sca_purchase_popup_modal_container').hide();
                    });
                }

            }


        });
    }
}
